import React from "react";
import { Link } from "react-router-dom";
import PosterArt from "@/components/media/PosterArt";
import { Play } from "lucide-react";

export default function LiveChannelCard({ channel }) {
  return (
    <Link to={`/watch/${channel.slug}`} data-testid={`live-card-${channel.slug}`}
      className="group relative block w-[240px] md:w-[280px] shrink-0 rounded-xl overflow-hidden ycn-glass hover:border-white/20 transition-all">
      <div className="relative">
        <PosterArt title={channel.title} gradient={channel.poster_gradient} aspect="backdrop" showTitle={false} />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
        <div className="absolute top-3 left-3 flex items-center gap-1.5 px-2 py-1 rounded-md bg-red-600/95 text-white text-[10px] font-black tracking-wider">
          <span className="w-1.5 h-1.5 rounded-full bg-white ycn-live-dot" /> LIVE
        </div>
        <div className="absolute bottom-3 left-3 right-3">
          <div className="font-display text-lg font-extrabold uppercase tracking-tight leading-none">{channel.title}</div>
          <div className="mt-1 text-[11px] text-white/70">{channel.description}</div>
        </div>
      </div>
      <div className="p-3 flex items-center justify-between">
        <span className="text-xs text-white/60">Now streaming</span>
        <span className="inline-flex items-center gap-1 rounded-full bg-white text-black px-2.5 py-1 text-[11px] font-bold group-hover:bg-white/90 transition">
          <Play size={10} fill="currentColor" /> Watch
        </span>
      </div>
    </Link>
  );
}
